import React from "react";
import { MessengerService, PluginWrapper } from "@vlogr/plugin-sdk";
import { AddSubtitleButton } from "./components/addSutitleButton";
import "@fontsource/noto-sans";

interface IItem {
  type: string;
  file: string;
  size: string;
}

function App() {
  const messengerService = new MessengerService(window as unknown as Window);

  const create = (data: IItem[]) => {
    messengerService.create(data, (data: any): void => {
      // do nothing
    });
  };

  const componentCallback = (data: any): void => {
    create(data);
  };

  const handleInvoke = () => {
    messengerService.invokePlugin("Subtitle", () => {
      console.log("invokePlugin called");
    });
  };

  return (
    <PluginWrapper messenger={messengerService}>
      <div className="App">
        <AddSubtitleButton
          messenger={messengerService}
          getSubtitleData={componentCallback}
          handleInvoke={handleInvoke}
        />
      </div>
    </PluginWrapper>
  );
}

export default App;
